<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
    <g fill="#FFF" fill-rule="evenodd">
      <path
        d="M1.949 1.91a1.633 1.633 0 0 1 2.31 0l11.673 11.673a1.633 1.633 0 0 1-2.31 2.31L1.95 4.218a1.633 1.633 0 0 1 0-2.31"
      />
      <path
        d="M1.91 16.051a1.633 1.633 0 0 1 0-2.31L13.582 2.069a1.633 1.633 0 0 1 2.31 2.31L4.218 16.05a1.633 1.633 0 0 1-2.31 0"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'CloseIcon',
};
</script>
